// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const background = "PercentageBadge__background__FteeF";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const labels = "PercentageBadge__labels__JAMwa";
export const medium = "500";
export const percentageBadge = "PercentageBadge__percentageBadge__DJ+bE";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const shrinkText = "PercentageBadge__shrinkText__EE9FO";
export const slash = "PercentageBadge__slash__QvJYy";
export const stroke = "PercentageBadge__stroke__UNy0l";
export const svgContainer = "PercentageBadge__svgContainer__bAYdC";
export const textCenter = "PercentageBadge__textCenter__v4-No";
export const warning = "PercentageBadge__warning__mMbFa";